interface DragHandlerProps {
    extractPositionFromEvent: (event: React.DragEvent<HTMLElement>) => { x: number; y: number };
    setIsDragging: (value: boolean) => void;
    setDragStartPosition: (position: { x: number; y: number }) => void;
    isDragging: boolean;
    dragStartPosition: { x: number; y: number };
    movementDirection: { x: number; y: number };
    setMovementDirection: (callback: (prev: { x: number; y: number }) => { x: number; y: number }) => void;
    startingPosition: { bottom: number; left: number };
}

export const createDragHandlers = ({
    extractPositionFromEvent,
    setIsDragging,
    setDragStartPosition,
    isDragging,
    dragStartPosition,
    movementDirection,
    setMovementDirection,
    startingPosition
}: DragHandlerProps): {
    onDragStartHandler: (e: React.DragEvent<HTMLElement>) => void;
    onDragEndHandler: (e: React.DragEvent<HTMLElement>) => void;
} => {
    const onDragStartHandler = (event: React.DragEvent<HTMLElement>) => {
        event.stopPropagation();
        const startPosition = extractPositionFromEvent(event);
        setDragStartPosition(startPosition);
        if (!isDragging) {
            setIsDragging(true);
        }
    };

    const onDragEndHandler = (event: React.DragEvent<HTMLElement>) => {
        event.stopPropagation();
        setIsDragging(false);
        const element = event.currentTarget;
        const parentElement = event.currentTarget.parentElement;

        if (element && parentElement) {
            const parentContainerWidth = parentElement.clientWidth;
            const parentContainerHeight = parentElement.clientHeight;

            const position = extractPositionFromEvent(event);
            const dropMovement = {
                x: position.x - dragStartPosition.x,
                y: position.y - dragStartPosition.y
            };
            const borderThickness = 3;

            const movementLimits = {
                left: -startingPosition.left + borderThickness,
                bottom: startingPosition.bottom - borderThickness,
                right: parentContainerWidth - startingPosition.left - element.getBoundingClientRect().width - borderThickness,
                top: -parentContainerHeight + startingPosition.bottom + element.getBoundingClientRect().height + borderThickness
            };

            if (movementDirection.x + dropMovement.x < movementLimits.left) dropMovement.x = movementLimits.left - movementDirection.x;
            else if (movementDirection.x + dropMovement.x > movementLimits.right) dropMovement.x = movementLimits.right - movementDirection.x;

            if (movementDirection.y + dropMovement.y < movementLimits.top) dropMovement.y = movementLimits.top - movementDirection.y;
            else if (movementDirection.y + dropMovement.y > movementLimits.bottom) dropMovement.y = movementLimits.bottom - movementDirection.y;

            element.style.transform = `translate(${movementDirection.x + dropMovement.x}px, ${movementDirection.y + dropMovement.y}px`;

            setMovementDirection((prevState) => ({
                x: prevState.x + dropMovement.x,
                y: prevState.y + dropMovement.y
            }));
        }
    };

    return { onDragStartHandler, onDragEndHandler };
};
